<template>
  <div>
    <DarkOverlay />
    <main class="dashboard">
      <div class="form-group stacked-labels checkboxes" />
      <section
        v-if="searchState !== 'closed'"
        id="infLoadArea"
        class="content-area"
      >
        <div class="content_container_nav content_container_nav--search">
          <form
            id="search-form"
            @submit.prevent="performSearch"
          >
            <input
              ref="searchField"
              v-model="searchQuery"
              type="text"
              class="field_input_text search_icon_dashboard"
              value
              placeholder="Search"
            >
          </form>
          <button
            class="search_btn dashboard_search_close_btn"
            aria-label="Close search"
            @click="closeSearch"
          >
            <i
              class="fas fa-times"
              aria-hidden="true"
            />
          </button>
        </div>
        <div
          v-if="rallySearchResults.length > 0"
          class="dashboard_card_list_map"
        >
          <DashboardCard
            v-for="(item, $index) in rallySearchResults"
            :key="$index"
            :membership="item.membership"
            :rally="item.rally"
            :query-string="searchQuery"
          />
        </div>
        <div
          v-else
          class="dashboard_empty_container"
        >
          <i
            v-if="searchState === 'searching'"
            class="fas fa-spinner fa-spin search-spinner"
            title="Searching..."
          />
          <img
            v-else
            src="/icons/search_circle.svg"
            alt=""
          >
          <h3>{{ searchMessage }}</h3>
          <p>{{ searchSubtitle }}</p>
        </div>
      </section>
      <section
        v-else
        class="content-area"
      >
        <div class="content_container_nav content_container_nav--search">
          <button
            class="search_btn"
            aria-label="Search"
            @click="openSearch"
          >
            <i
              class="fas fa-search"
              aria-hidden="true"
            />
          </button>
        </div>
        <draggable
          v-model="rallyListing"
          :disabled="!allowMoveRallies"
          item-key="membership.id"
          group="people"
          @start="onDragStart"
          @end="onDragEnd"
        >
          <template #item="{ element, index }">
            <DashboardCard
              :key="index"
              :membership="element.membership"
              :rally="element.rally"
            />
          </template>
        </draggable>
        <div
          v-if="!isComplete"
          class="infinite-loading-container"
        >
          <infinite-loading
            ref="infLoad"
            :slots="{ complete: ' ' }"
            @infinite="infiniteHandler"
          />
          <i
            class="fas fa-spinner fa-spin search-spinner"
            title="Loading..."
          />
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { assembleRallyObject, RRS_URL } from "../common";
import RallyPaginationMixin from "../components/RallyPaginationMixin";
import { eventBus } from "../main.js";  
import { PushNotification } from "@capacitor/core";
import { userInfo, syncTimezone } from "../common/user-info";
import { buildServiceParamMap, enrichDataWithIncluded, isMobile } from "../common/utils";
import { isMoment } from "moment";
import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";
import DashboardCard from "../components/DashboardCard"
import jwtInterceptor from '../common/jwt-interceptor';

export default {
  name: "DashboardPage",
  components: {
    DashboardCard,
  },
  mixins: [RallyPaginationMixin],
  data() {
    return {
      drag: false,
      isComplete: false,
      rallySearchResults: [],
      searchQuery: '',
      searchState: 'closed',
      tempSortOrder: {},
    };
  },
  computed: {
    ...mapState("rallies", ["myRallies", "moveRallies"]),
    ...mapState("user", ["status", "usersById"]),
    allowMoveRallies(){
      return !isMobile() || this.moveRallies
    },
    rallyListing() {
      let rs = [...this.myRallies]; // Copy the myRallies array

      // Remove entries where rally attribute is missing
      rs = rs.filter(item => item?.rally?.attributes?.title);
      rs = rs.filter(item => item?.rally?.attributes?.viewable);
      rs = rs.filter(item => (item?.rally?.attributes?.status == "Active") || (item?.rally?.attributes?.status == "Archived" && item?.membership?.attributes?.role == "Owner" && item?.membership?.attributes?.status == "Active") );

      if (rs && Array.isArray(rs)) {
        rs = this.membershipSort(rs)
      } else {
        console.warn("rs is not an array or is undefined");
      }
      
      return rs
    },
    searchMessage() {
      switch ( this.searchState ) {
        case 'searching':
          return 'Searching...'
          break
        case 'failed':
          return 'No search results found'
          break
        default:
          return 'Search for a Rally, Hub or Organization'
      }
    },
    searchSubtitle() {
      switch ( this.searchState ) {
        case 'failed':
          return 'Nothing matched your search, but a different keyword or fewer filters might help.'
          break
        default:
          return null
      }
    },

  },
  created() {
    syncTimezone();
    this.fetchDashboardRallies()
  },
  methods: {
    ...mapActions("rallies", ["clearRallyState", "fetchMyRalliesWithInfo"]),
    ...mapActions("user", ["registerUserDevice"]),
    ...mapActions("memberships", ["changeSort"]),
    closeSearch() {
      this.rallysearchResults = []
      this.searchQuery = ''
      this.searchState = 'closed'
    },
    membershipSort(rs){
      return rs.sort((a, b) => {
          if ( a?.rally?.attributes && a?.membership?.attributes && b?.rally?.attributes && b?.membership?.attributes){
            let sa = this.tempSortOrder[a.membership.id] != null ? this.tempSortOrder[a.membership.id] : a.membership.attributes['sort-order']
            let sb = this.tempSortOrder[b.membership.id] != null ? this.tempSortOrder[b.membership.id] : b.membership.attributes['sort-order']
            if (sa ==  null){
              sa = 10000
            }
            if (sb == null){
              sb = 10000
            }
            if (a.rally.attributes.status == 'Archived'){
              sa = 10001
            }
            try{
              if (b.rally.attributes.status == 'Archived'){
                sb = 10001
              }
            } catch (e){
              console.log(e)
            }
            if (sa < sb){
              return -1
            } else if (sa > sb) {
              return 1
            }
            return 0;
          } else {
            console.warn("Missing rally attributes:", a);  
            return 0;
          }
        });
      },
    moveElement(arr, fromIndex, toIndex) {
      arr.splice(toIndex, 0, arr.splice(fromIndex, 1)[0])
      return arr
    },
    onDragStart(evt) {
      this.drag = true; // Set drag state to true when dragging starts
    },
    async onDragEnd(evt) {
      this.drag = false; // Reset drag state

      eventBus.emit('overlayOn')
      const newOrder = this.moveElement(this.rallyListing, evt.oldIndex, evt.newIndex)
      await this.changeSort({membershipIdOrdering: newOrder})
      eventBus.emit('overlayOff')
    },
    openSearch() {
      this.searchQuery = ''
      this.searchState = 'open'
      setTimeout(() => {
        this.$refs.searchField.focus()
      }, 500)
    },
    async fetchDashboardRallies() {
      // TODO - clear out the rally state whenever this page is loaded due to the fact that
      // rallies that the user may not be an explicit member of may be loaded into the state
      // as the user clicks on the rabbit-trail links to Hubs
      // Eventually we should keep the state of the rallies that the user is a member of in a separate state
      //await this.clearRallyState()
      await this.fetchMyRalliesWithInfo({})
    },
    async infiniteHandler($state) {
      let beforesize = this.rallyListing.length
      await this.fetchMyRalliesWithInfo({})
      if (beforesize == this.rallyListing.length){
        this.isComplete = true
        $state.complete()
      } else {
        $state.loaded()
      }
    },
    async searchRallies() {
      const user = userInfo();
      const jsonparams = {
        include: "avatar,is_hub,member_count,my_membership",
        rally_type: ['Rally', 'Standard'],
        "page[number]": 1,
        "page[size]": "200",
        query: this.searchQuery,
        user_id: user.user_id,
        status: 'Active'
      }
      const params = buildServiceParamMap(jsonparams)
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        },
        url: RRS_URL() + "/rallies",
        params
      }
      const response = await jwtInterceptor(requestOptions);
      if ( response?.data?.data?.length > 0 ) {
        const enrichedRallies = enrichDataWithIncluded(response)
        const rallyObjs = {}
        for (const rally of enrichedRallies) {
          rallyObjs[rally.id] = { id: rally.id, rally: rally, membership: rally.attributes['my-membership'] }
        }
        this.rallySearchResults = Object.values(rallyObjs)
        this.$store.dispatch("contents/setIncludedById", { included: response.data.included, avatarType: "rally" })
      } else {
        this.searchState = 'failed'
      }
    },
    async performSearch() {
      this.searchState = 'searching'
      this.rallySearchResults = []
      try {
        await this.searchRallies()
      } finally {
        this.searchState = 'failed'
      }
    },
  }
};
</script>
